import type { WilsonAccessTiers } from "@/hooks/useWilsonAccessTiers.utils"

const SETUP_ICONS_PREFIX = "/setup/icons/"
const DARK_ICONS_PREFIX = "/setup/icons/dark/"

type WilsonContentKey = "memories" | "rules" | "skills"

export function resolveWilsonContentAccess(
    key: WilsonContentKey,
    tiers: WilsonAccessTiers
): { isVisible: boolean; canEdit: boolean } {
    if (key === "memories") {
        return {
            isVisible: tiers.canViewMemories,
            canEdit: tiers.canEditMemories,
        }
    }
    if (key === "skills") {
        return {
            isVisible: tiers.canManageSkills,
            canEdit: tiers.canManageSkills,
        }
    }
    return {
        isVisible: tiers.canManageGlobalRules,
        canEdit: tiers.canManageGlobalRules,
    }
}

export function resolveHeroIconSrc(icon: string, isDark: boolean): string {
    if (!isDark || !icon.startsWith(SETUP_ICONS_PREFIX)) return icon
    return DARK_ICONS_PREFIX + icon.slice(SETUP_ICONS_PREFIX.length)
}
